import React from "react";
import { Autocomplete, TextField, useMediaQuery } from "@mui/material";

const AutoCompleteCourse = ({
  formData,
  setFormData,
  courseData,
  field,
  disabled,
  course,
}: any) => {
  const isLargeScreen = useMediaQuery("(max-width: 600px)");

  const selectedCourse =
    (Array.isArray(course) ? course[0] : course) ||
    courseData?.data?.results.find((item: any) => item.id === formData.course);

  return (
    <>
      <div className="font-inter font-medium text-xs text-[#404D61] px-1 flex items-center gap-x-1 mb-1">
        {field.icon}
        <label className="text-sm lg:text-base">{field.label}</label>
      </div>
      <Autocomplete
        disabled={!!course || disabled}
        value={selectedCourse || null}
        onChange={(event, newValue) =>
          setFormData({
            ...formData,
            course: newValue ? newValue.id : null,
          })
        }
        options={
          Array.isArray(course)
            ? course
            : courseData?.data?.results?.map((item: any) => ({
                ...item,
                uniqueKey: `${item.id}-${item.abbreviation}`,
              })) || []
        }
        getOptionLabel={(option) => option?.abbreviation || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={field.placeholder}
            required
            className="w-full text-xs text-gray-600"
            InputProps={{
              ...params.InputProps,
              sx: {
                fontSize: "0.75rem",
                height: "32px",
              },
            }}
          />
        )}
        ListboxProps={{
          style: {
            maxHeight: isLargeScreen ? "160px" : "220px",
            overflow: "auto",
            fontSize: "0.75rem",
          },
        }}
        renderOption={(props, option) => (
          <li
            {...props}
            key={option.uniqueKey}
            style={{
              backgroundColor:
                selectedCourse?.id === option.id ? "#e7effa" : "",
              color: selectedCourse?.id === option.id ? "#000" : "",
              padding: "5px",
            }}
          >
            {option.abbreviation}
          </li>
        )}
        sx={{
          width: "100%",
          "& .MuiAutocomplete-option": {
            py: 0.5,
            fontSize: "0.875rem",
          },
          "& .MuiAutocomplete-input": {
            px: 1,
            py: 0.5,
            fontSize: "0.75rem",
          },
        }}
      />
    </>
  );
};

export default AutoCompleteCourse;
